import React from 'react';
import { Container, Navbar, NavbarBrand, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import LoginMenu from 'features/auth/LoginMenu';
import {RootState} from '../rootReducer';
import {User} from 'oidc-client';
import {connect, ConnectedProps} from 'react-redux';

type Props = ConnectedProps<typeof connector>;

class NavMenu extends React.Component<Props> {
    render () {
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
                    <Container>
                        <NavbarBrand tag={Link} to="/">Berlitz 2.0 Image Cropper</NavbarBrand>
                        <ul className="navbar-nav flex-grow">
                            <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/uploads">Upload files</NavLink>
                            </NavItem>
                            {this.props.isUserAdmin && <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/users">Manage users</NavLink>
                            </NavItem>}
                            <LoginMenu />
                        </ul>
                    </Container>
                </Navbar>
            </header>
        );
    }
}

const mapStateToProps = (state: RootState) => {
    const user = state.oidc.user as User;
    return {
        isUserAdmin: user?.profile?.role === 'Admin'
    };
};

const connector = connect(mapStateToProps);
export default connector(NavMenu);